export interface DashboardContentItemsModels {
    chartType: typeDashboardContentChartTypes;
    contentTitle: string;
    filterOption: boolean;
    filterPopup: boolean;
    dateFilter: string;
    otherFilters?: DashboardContentItemsModelsOtherFilters[],
    componentName: string;
    selectedWindow: string;
}

export interface DashboardContentItemsModelsOtherFilters {
    filterType: string;
    filterValue: string;
}

export const DashboardContentChartTypes = {
    reports: "reports",
    charts: "charts",
    table: "table",
    summary: "summary"
} as const;
export type typeDashboardContentChartTypes = typeof DashboardContentChartTypes[keyof typeof DashboardContentChartTypes];
